import {useAlertasDeReservas} from '../api/reservas';
import {tr} from '../i18n/idioma';
import {Pestanas} from './pestanas-inventario';
import {useVe} from './sesion-contexto';

// Subsecciones de Exportaciones (menu nuevo, 6/10/2026): todo el trabajo de
// embarque junto. Cada una tiene sus propios filtros, asi que al cambiar de
// pestana no se llevan los de la otra.
export function PestanasSeguimiento() {
  const alertas = useAlertasDeReservas(useVe('exportaciones.reservas'));
  const pendientes = alertas.data?.pendientes ?? 0;
  const pestanas = [
    {a: '/seguimiento', texto: tr('Exportaciones', 'Exports'), area: 'exportaciones.seguimiento'},
    {a: '/seguimiento/reservas', texto: tr('Reservas', 'Bookings'), area: 'exportaciones.reservas'},
    {
      a: '/seguimiento/alertas-de-reservas',
      area: 'exportaciones.reservas',
      texto: `${tr('Alertas de reservas', 'Booking alerts')}${pendientes ? ` (${pendientes})` : ''}`,
    },
    {
      a: '/seguimiento/contenedores',
      texto: tr('Contenedores (logística)', 'Containers (logistics)'),
      area: 'exportaciones.contenedores',
    },
    {a: '/seguimiento/gex', texto: tr('GEX · Trámite de aduana', 'GEX · Customs filing'), area: 'exportaciones.gex'},
    {a: '/seguimiento/financiaciones', texto: tr('Financiaciones', 'Financing'), area: 'exportaciones.financiaciones'},
    {a: '/seguimiento/navieras', texto: tr('Navieras', 'Shipping lines'), area: 'exportaciones.navieras'},
    // Certificados de origen y de analisis (decision 0067).
    {a: '/seguimiento/certificados', texto: tr('Certificados', 'Certificates'), area: 'exportaciones.certificados'},
  ];
  return <Pestanas pestanas={pestanas} nombre={tr('Secciones de exportaciones', 'Export sections')} />;
}
